export default {
	"Progress.remainder": "remainder"
}